import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
  siteKey: '6Lf8XowqAAAAALx-Vkhgle_-Xx7gzwf6yTw8I3mO',
  loaderOptions: {
    useRecaptchaNet: true
  }
})

export default VueReCaptcha